import Manager from './Manager.component';

export default Manager;
